import { useApplicationCvFileId } from '@/domain/job-application/contexts';

export const useIsUpdateProfileEnabled = () => {
  const cvFileId = useApplicationCvFileId();

  return !!cvFileId;
};
